<template>
    <resource-index title="Продажи" endpoint="admin/billing/orders">
        <template slot="header-buttons">
            <router-link
                class="btn btn-secondary"
                :to="{
                    name: 'admin.billing.orders.create',
                }"
            >Создать</router-link>
        </template>

        <template v-slot:table-header>
            <tr class="border-b">
                <th class="text-left p-3 px-5" scope="col">Товар</th>
                <th class="text-left p-3 px-5" scope="col">Счет</th>
                <th v-if="false" class="text-left p-3 px-5" scope="col">Продавец</th>
                <th class="text-left p-3 px-5" scope="col">Клиент</th>
                <th class="text-left p-3 px-5" scope="col">Стоимость</th>
                <th class="text-left p-3 px-5" scope="col">Статус</th>
                <th class="text-left p-3 px-5" scope="col">Дата</th>
                <th class="text-left p-3 px-5" scope="col"></th>
            </tr>
        </template>

        <template v-slot:table-filters="slotProps">
            <tr class="border-b bg-gray-100">
                <th class="p-3 px-5" scope="col">
                    <text-field
                        placeholder="Название или ID"
                        :wrap="false"
                        v-model="slotProps.filters.product_name"
                    />
                </th>

                <th class="p-3 px-5" scope="col">
                    <select-field
                        label="name"
                        valueName="id"
                        :wrap="false"
                        :options="selects.accounts"
                        v-model="slotProps.filters.account_id"
                    />
                </th>

                <th v-if="false" class="p-3 px-5" scope="col">
                    <text-field :wrap="false" v-model="slotProps.filters.seller" />
                </th>

                <th class="p-3 px-5" scope="col">
                    <text-field :wrap="false" v-model="slotProps.filters.customer" />
                </th>

                <th class="p-3 px-5" scope="col"></th>
                <th class="p-3 px-5" scope="col"></th>

                <th class="p-3 px-5" scope="col"></th>

                <th class="p-3 px-5" scope="col"></th>
            </tr>
        </template>

        <template v-slot:row="slotProps">
            <td class="p-3 px-5">
                <span
                    v-if="slotProps.entry.product.category.rentable"
                >{{ slotProps.entry.product.unique_id }} –</span>
                {{ slotProps.entry.product.name }}
            </td>

            <td class="p-3 px-5">{{ slotProps.entry.amounts.length ? slotProps.entry.amounts[0].account.name : null }}</td>

            <td class="p-3 px-5" v-if="false">{{ slotProps.entry.seller.full_name }}</td>

            <td class="p-3 px-5">{{ slotProps.entry.customer.full_name }}</td>

            <td class="p-3 px-5">
                <span class="badge whitespace-no-wrap badge-success">{{ slotProps.entry.amount }} ₽</span>
            </td>

            <td class="p-3 px-5">
                <span
                    class="badge whitespace-no-wrap badge-success"
                    v-if="slotProps.entry.is_paid"
                >Оплачен</span>
                <span class="badge whitespace-no-wrap badge-indigo" v-else>Ожидание</span>
            </td>

            <td class="p-3 px-5">{{ localTime(slotProps.entry.sold_at) }}</td>

            <td class="p-3 px-5">
                <router-link
                    :to="{
                        name: 'admin.billing.orders.edit',
                        params: {
                            id: slotProps.entry.id
                        }
                    }"
                    class="btn btn-info"
                >Изменить</router-link>
            </td>
        </template>
    </resource-index>
</template>

<script>
import ResourceIndex from "@/components/Resource/ResourceIndex";

export default {
    components: {
        ResourceIndex
    },

    data() {
        return {
            selects: {
                ready: false,
                products: [],
                accounts: []
            }
        };
    },

    methods: {
        async fetchSelects() {
            /*
            await axios.get("/admin/products/all").then(response => {
                this.selects.products = response.data.data;
            });
            */

            await axios.get("/admin/assets/accounts/all").then(response => {
                this.selects.accounts = response.data.data;
            });

            this.selects.ready = true;
        }
    },

    mounted() {
        this.fetchSelects();
    }
};
</script>
